import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="external-links"
export default class extends Controller {
  connect() {
    console.log("🔗 External links controller connected")
    this.processLinks()
  }

  disconnect() {
    console.log("🔗 External links controller disconnected")
  }

  processLinks() {
    // Find all links within this controller's scope
    const links = this.element.querySelectorAll('a[href]')
    let processedCount = 0

    links.forEach(link => {
      if (this.isExternalLink(link)) {
        // Add target and rel attributes for external links
        link.setAttribute('target', '_blank')
        link.setAttribute('rel', 'noopener noreferrer')
        processedCount++

        console.log(`🌐 Made external link open in new tab: ${link.href}`)
      }
    })

    if (processedCount > 0) {
      console.log(`🔗 Processed ${processedCount} external links`)
    }
  }

  isExternalLink(link) {
    try {
      const href = link.getAttribute('href')

      // Skip if no href
      if (!href) return false

      // Skip internal anchors
      if (href.startsWith('#')) return false

      // Skip mailto, tel, etc.
      if (href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('sms:')) return false

      // Skip javascript: links
      if (href.startsWith('javascript:')) return false

      // For relative URLs, they are internal
      if (href.startsWith('/') && !href.startsWith('//')) return false

      // For protocol-relative URLs (//example.com), create URL to check hostname
      if (href.startsWith('//')) {
        const url = new URL('https:' + href)
        return url.hostname !== window.location.hostname
      }

      // For absolute URLs, check if hostname is different
      if (href.match(/^https?:\/\//)) {
        const url = new URL(href)
        return url.hostname !== window.location.hostname
      }

      // Relative paths are internal
      return false

    } catch (error) {
      console.warn('Error processing link:', link.href, error)
      return false
    }
  }

  // Action method to reprocess links when content changes dynamically
  refresh() {
    console.log("🔄 Refreshing external links processing")
    this.processLinks()
  }
}